// src/components/NotificationToast.js
import React, { useEffect } from "react";
import styles from "../css/shared.module.css";
import { FiCheckCircle, FiXCircle, FiX } from "react-icons/fi";

const NotificationToast = ({ notification, onClose }) => {
  // ✅ El Hook se mueve al principio, antes de cualquier condición
  useEffect(() => {
    // Si la notificación no se muestra, no hacemos nada con el temporizador
    if (!notification.show) {
      return;
    }

    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [notification, onClose]);

  // ✅ La condición para no renderizar se mantiene aquí
  if (!notification.show) {
    return null;
  }

  const isSuccess = notification.type === "success";
  const icon = isSuccess ? <FiCheckCircle /> : <FiXCircle />;
  const toastClass = isSuccess ? styles.toastSuccess : styles.toastError;

  return (
    <div className={`${styles.toast} ${toastClass}`}>
      <div className={styles.toastIcon}>{icon}</div>
      <p className={styles.toastMessage}>{notification.text}</p>
      <button onClick={onClose} className={styles.toastCloseButton}>
        <FiX />
      </button>
    </div>
  );
};

export default NotificationToast;
